import { IProfileErrors } from "../../components/Profile/Profile.types";

export const emptyStringToNull = (value: any, originalValue: any) => {
  if (typeof originalValue === "string" && originalValue === "") {
    return null;
  }
  return value;
};

export const parseErrorMessage = (
  validationErrors: IProfileErrors,
  errorMessage: string
): string => {
  const errorValues = Object.values(validationErrors).filter((v) => !!v);
  if (errorValues.length === 1) {
    return errorValues[0];
  }
  return errorMessage;
};
